require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-hosted-vs-self-hosted-comparison-for-e-commerce.json") })
        }
      }, "path---blog-a-hosted-vs-self-hosted-comparison-for-e-commerce");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-hosted-vs-self-hosted-comparison-for-e-commerce!./.cache/json/blog-a-hosted-vs-self-hosted-comparison-for-e-commerce.json
// module id = 422
// module chunks = 231608221292675